export default "__VITE_ASSET__CSPncx2O__";